// extracted by mini-css-extract-plugin
export default {"container_option":"Option_container_option__XZAtX","container_info":"Option_container_info__faOrJ","color_option":"Option_color_option__94l5I","checked":"Option_checked__wets7"};